import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { CONSTANTS_DATA } from '@fitness-force/constants';

import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'trial-type',
  templateUrl: './trial-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
  ]
})
export class TrialTypeComponent {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);
  @Output() onAction = new EventEmitter(); // {type:actionName,columnData }


  getTrialType(activeTrial: any) {
    return CONSTANTS_DATA.TRIALS_TYPE.find((item) => (item.key === activeTrial.type))?.name;
  }


  executeAction(action: string, columnData: any) {
    this.onAction.emit({ action, columnData });
  }

}
